<template>
  <vx-tooltip :text="isTransfer ? $t('untransfer') : $tc('transfer')" position="bottom">
    <vs-button
      class="includeIcon includeIconOnly"
      color="success"
      :type="isTransfer ? 'filled' : 'border'"
      @click="isTransfer ? unTransfer() : transfer()">
      <i class="c-icon-transfer"></i>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Cti from '@/models/Cti'

export default {
  name: 'CtiTransfer',
  props: {
    server: {
      required: true
    },
    isDisplay: {
      default: false
    },
    size: {
      default: 'sm'
    }
  },
  computed: {
    phoneNumber () {
      return this.$store.getters.phoneNumber
    },
    extension () {
      return this.$store.getters.extension
    },
    isTransfer () {
      return this.$store.getters.isTransfer
    }
  },
  mounted () {
    this.checkTransfer()
  },
  methods: {
    async transfer () {
      if (this.isDisplay) {
        return
      }

      if (this.phoneNumber === null || this.phoneNumber.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Phone Number is Required.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      const data = {
        extension: this.extension,
        channel: this.phoneNumber
      }

      try {
        await Cti.transfer(this.server.domain, data)
        await this.checkTransfer()
        localStorage.setItem('phoneNo', this.phoneNumber)
        this.$vs.notify({
          title:'CTI Notice',
          text:`${this.phoneNumber} ${this.$t('transferred')}`,
          color:'success',
          position:'top-right'
        })
      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Transfer Error',
          color:'danger',
          position:'top-right'
        })
      }
    },
    async unTransfer () {
      if (this.isDisplay) {
        return
      }

      const data = {
        extension: this.extension,
        channel: this.phoneNumber
      }

      try {
        await Cti.unTransfer(this.server.domain, data)
        await this.checkTransfer()
        this.$vs.notify({
          title:'CTI Notice',
          text:`${this.phoneNumber} ${this.$t('untransferred')}`,
          color:'success',
          position:'top-right'
        })
      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'UnTransfer Error',
          color:'danger',
          position:'top-right'
        })
      }
    },
    async checkTransfer () {
      if (this.isDisplay) {
        return
      }

      try {
        const response = await Cti.checkTransfer(this.server.domain, {
          data: this.extension
        })

        if (response.data.channel.length > 0) {
          this.$store.dispatch('setPhoneNumber', response.data.channel)
        }

        if (response.data.exist.toString() === '1') {
          this.$store.dispatch('updateIsTransfer', true)
        } else {
          this.$store.dispatch('updateIsTransfer', false)
        }
      } catch (e) {
        this.$alertHelper.error('Check Transfer Error')
      }
    }
  }
}
</script>

<style scoped>

</style>
